<template>
  <div class='container products-wrapper'>
    <div class='categories-sidebar' :class="{'sidebar-opened': sidebarOpened}">
      <div class='mobile-sidebar-close' @click="toggleSidebar">
        <span></span>
        <span></span>
      </div>
      <div class='sidebar-mobile-logo'>
        <img src="/assets/logo/brand-logo-white.png" alt="Musichenko" class='img-fluid'>
      </div>
      <h3 class='h3-title'>
        Категорії
      </h3>
      <div class='categories-wrapper paragraph-s'>
        <div class='category-item c-p h4-title' :class="{'selected': !selectedCategory }"  @click="selectAll()" v-if="productCategories.length !== 0">
          Всі товари
        </div>
        <h4 class="category-item c-p d-flex h4-title" :class="{'selected': selectedCategory === Number(item.id)}"
        v-for="item of productCategories" :key="item.id" @click="selectCategory(item.id)">
          {{item.name}}
        </h4>
        <div v-if="productCategories.length === 0" class='paragraph-s text-asset'>
          завантаження категорій...
        </div>
      </div>
    </div>
    <div class='products-results'>
      <h3 class='h3-title products-title'>
        {{selectedCategoryName}} ({{filteredProductsList.length}})
      </h3>
      <div class="products-results-wrapper" v-if="!requestFailed">
        <div class="product-item" v-for='item of currentPageProductList' :key="item.id">
          <div class="product-image mb-s" @click="redirectToProductView(item.id)">
            <app-image
              :width="213"
              :height="320"
              :lazy-src="item.preview"
              :alt='item.name'
            />
            <div class='hidden-show-more fw-bold'>
              <button class='app-btn app-btn-primary app-btn-small'>Переглянути</button>
            </div>
          </div>
          <div class='product-name text-italic'>
            <span class='mr-s'>{{productPrefix(item.category)}}</span>
            <span v-if="item.name" class='text-italic'>"{{item.name}}"</span>
            <span v-else class='text-italic'>"{{item.code}}"</span>
          </div>
        </div>
        <div v-if="currentPageProductList.length === 0" class='p-m paragraph-s text-asset'>
          завантаження списку товарів...
        </div>
      </div>
      <div class='text-primary p-m' v-else>
        <div class='mb-l'>Не вдалося отримати список товарів :(</div>
        <div class='app-btn app-btn-primary outline app-btn-small' @click="getProductList">Спробувати ще раз</div>
      </div>
      <div class='product-pagination' v-if="this.paginationPageCount > 1">
        <app-pagination ref='pagination' :onChangePage='changePage' :count='this.paginationPageCount'></app-pagination>
      </div>
    </div>
    <div class='sidebar-second-background' v-if="sidebarOpened" @click="toggleSidebar"></div>
    <div class='mobile-sidebar-toggler' @click="toggleSidebar">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AppImage from '@/components/common/AppImage.vue'
import AppPagination from '@/components/common/AppPagination.vue'
import router from '@/router.js'
import productPrefixFunction from '@/utils/productArticle.js'

export default {
  data () {
    return {
      selectedCategory: null,
      allProductsList: [],
      filteredProductsList: [],
      currentPageProductList: [],
      paginationPageCount: null,
      requestFailed: false,
      sidebarOpened: false
    }
  },
  name: 'Products',
  components: {
    AppImage,
    AppPagination
  },
  computed: {
    ...mapState([
      'productCategories',
      'productsList'
    ]),
    selectedCategoryName () {
      if (this.selectedCategory) {
        const category = this.productCategories.find(
          (el) => Number(el.id) === this.selectedCategory
        )
        return category.name
      } else {
        return 'Всі товари'
      }
    }
  },
  methods: {
    productPrefix (id) {
      return productPrefixFunction(id)
    },
    selectCategory (id) {
      this.selectedCategory = Number(id)
      if (this.selectedCategory) {
        this.filterProductsByCategory(this.allProductsList, this.selectedCategory)
      } else {
        this.filteredProductsList = this.allProductsList
        this.calculatePaginationPagesCount()
      }
      if (this.sidebarOpened) {
        this.toggleSidebar()
      }
      this.scrollTop()
    },
    changePage (page) {
      this.generatePaginationPages(this.filteredProductsList, page)
      this.scrollTop()
    },
    filterProductsByCategory (products, category) {
      this.filteredProductsList = products.filter(product => Number(product.category) === category)
      this.calculatePaginationPagesCount()
    },
    calculatePaginationPagesCount () {
      this.currentPageProductList = []
      this.paginationPageCount = 0
      this.paginationPageCount = Math.ceil(this.filteredProductsList.length / 6)
      if (this.paginationPageCount > 1) {
        this.generatePaginationPages(this.filteredProductsList, 1)
        this.$nextTick(() => {
          this.$refs.pagination.renderItems()
        })
      } else {
        this.currentPageProductList = this.filteredProductsList
      }
    },
    generatePaginationPages (filteredProducts, currentPage) {
      const finish = currentPage * 6
      const start = finish - 6
      this.currentPageProductList = filteredProducts.slice(start, finish)
    },
    selectAll () {
      this.selectedCategory = null
      this.filteredProductsList = this.allProductsList
      this.calculatePaginationPagesCount()
      if (this.sidebarOpened) {
        this.toggleSidebar()
      }
    },
    scrollTop () {
      if (window.pageYOffset > 0) {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      }
    },
    toggleSidebar () {
      this.sidebarOpened = !this.sidebarOpened
      document.body.classList.toggle('no-scroll', this.sidebarOpened)
    },
    getProductList () {
      this.requestFailed = false
      this.$store.dispatch('loadProductsList').then(
        (responseProducts) => {
          this.allProductsList = responseProducts
          this.selectCategory(this.$route.params.cat_id)
        },
        (error) => {
          console.log(error)
          this.requestFailed = true
        }
      )
    },
    redirectToProductView (id) {
      router.push(`/products/${id}`)
    }
  },
  mounted () {
    if (this.productCategories.length === 0) {
      this.$store.dispatch('loadProductCategories')
    }
    this.getProductList()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/_sizes.scss';
.mobile-sidebar-toggler {
  display: none;
}
.products-wrapper {
  margin-top: 60px;
  padding: 50px 0;
  min-height: calc(50vh - 60px - 50px - 50px);
  display: flex;
  .categories-sidebar {
    width: 260px;
    padding: 10px 0 10px 0;
    position: fixed;
    transition: left 0.45s ease-in-out;
    .mobile-sidebar-close {
      display: none;
    }
    .sidebar-mobile-logo {
      display: none;
      height: 60px;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      & img {
        height: 45px;
      }
    }
    .categories-wrapper {
      margin-top: 15px;
      border-left: 1px solid $primary-color;
      .category-item {
        padding: 10px;
        border-radius: 10px;
        transition: all 0.3s ease-in-out;
        user-select: none;
        &:hover {
          color: $primary-color;
        }
        &.selected {
          padding: 10px 10px 10px 20px;
          color: $primary-color;
        }
      }
    }
  }
  .products-results {
    padding: 10px 0;
    width: 100%;
    margin-left: 260px;
    .products-title {
      padding: 0 10px;
    }
    .products-results-wrapper {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
      min-height: 762px;
      .product-item {
        padding: 10px;
        text-align: center;
        max-width: 213px;
        font-size: 15px;
        .product-image {
          position: relative;
          overflow: hidden;
          display: flex;
          .hidden-show-more {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: $half-asset-color;
            color: $white-color;
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
          }
          &:hover .hidden-show-more  {
            opacity: 1
          }
        }
      }
    }
  }
  .product-pagination {
    min-height: 34px;
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
}

@media(max-width: $laptop) {
  .mobile-sidebar-toggler {
    display: flex;
    position: fixed;
    top: 140px;
    left: 0;
    right: 0;
    z-index: 100;
    cursor: pointer;
    height: 45px;
    width: 45px;
    background-color: $asset-color;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      height: 2px;
      width: 30px;
      background-color: $white-color;
      margin-bottom: 6px;
      margin-right: 8px;
      display: flex;
      &:last-child {
        margin-bottom: 0
      }
    }
  }
  .products-wrapper {
    padding: 30px 0;
    .categories-sidebar {
      width: 280px;
      position: fixed;
      top: 0;
      left: -320px;
      bottom: 0;
      background-color: $asset-color;
      padding: 20px;
      color: $white-color;
      z-index: 1200;
      overflow-y: auto;
      .mobile-sidebar-close {
        position: absolute;
        display: flex;
        right: 12px;
        top: 12px;
        height: 32px;
        width: 32px;
        align-content: center;
        justify-items: center;
        cursor: pointer;
        span {
          width: 28px;
          height: 2px;
          background-color: $white-color;
          display: flex;
          position: absolute;
          top: 15px;
          left: 2px;
          &:first-child {
            transform: rotate(45deg);
          }
          &:last-child {
            transform: rotate(135deg);
          }
        }
      }
      .sidebar-mobile-logo {
        display: flex;
      }
      &.sidebar-opened {
        left: 0;
      }
      .categories-wrapper {
        border-left: 1px solid $white-color;
      }
    }
    .products-results {
      margin-left: 0;
      .products-results-wrapper {
        justify-content: center;
        min-height: 762px;
      }
    }
    .product-pagination {
      justify-content: center;
      display: flex;
      padding: 0 10px;
      min-height: 34px;
    }
    .sidebar-second-background {
      position: fixed;
      background-color: $half-black-color;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1100;
    }
  }
}
@media(max-width: $mobile) {
  .products-wrapper {
    .products-results {
      .products-results-wrapper {
        min-height: 380px;
      }
    }
  }
}

</style>
